import { Distance } from '.';
import { Locale } from '../internationalization';

export const getLocaleDistanceUnits = (locale = Locale.DEFAULT_LOCALE) => {
  switch (locale) {
    case Locale.EN_US:
    case Locale.EN_GB:
      return Distance.MI;
    default:
      return Distance.KM;
  }
};
